import React, { useState, useEffect } from 'react';
import { RiCloseCircleLine } from "react-icons/ri";
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../contexts/ContextProvider';
import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';
import axios from 'axios'; // Para hacer la petición
import moment from 'moment'; // Para manejar fechas
import { FaWhatsapp } from "react-icons/fa"; // Asegúrate de importar el ícono
import LoadingOverlay from './LoadingOverlay';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

registerLocale('es', es);

const NavButton = ({ title, customFunc, icon, color, size = 'xl', padding = 'p-3' }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={customFunc}
      style={{ color }}
      className={`relative text-${size} rounded-full ${padding} hover:bg-light-gray`}
    >
      {icon}
    </button>
  </TooltipComponent>
);

const Toast = ({ message, type, onClose }) => {
  if (!message) return null;
  const bg = type === 'error' ? '#fee2e2' : '#fef9c3';
  const border = type === 'error' ? '#f87171' : '#fbbf24';
  const text = type === 'error' ? '#991b1b' : '#92400e';
  return (
    <div style={{ background: bg, border: `1px solid ${border}`, color: text, borderRadius: 8, padding: '10px 14px', marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', fontSize: 14 }}>
      <span>{message}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold', color: text, marginLeft: 10 }}>✕</button>
    </div>
  );
};

const DetalleOrden = ({ cotizacionId, onClose, ordenId, refreshOrdenes }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [toast, setToast] = useState({ message: '', type: '' });
  const [isEditing, setIsEditing] = useState(false);
  const [selectedInstalador, setSelectedInstalador] = useState('');
  const [fechaInstalacion, setFechaInstalacion] = useState(null);
  const [rangoHoras, setRangoHoras] = useState('');
  const [numeroSeguimiento, setNumeroSeguimiento] = useState('');
  const [vehiculos, setVehiculos] = useState([]);
  const [fechaCotizacion, setFechaCotizacion] = useState('');
  const [horariosDisponibles, setHorariosDisponibles] = useState([
    { value: '9-12', label: '9:00 AM - 12:00 PM', disponible: true },
    { value: '12-15', label: '12:00 PM - 3:00 PM', disponible: true },
    { value: '15-18', label: '3:00 PM - 6:00 PM', disponible: true },
  ]);
  const { currentColor } = useStateContext();
  const [cotizacion, setCotizacion] = useState(null);
  const [orden, setOrden] = useState(null);
  const [cliente, setCliente] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalM2, setTotalM2] = useState(0);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  useEffect(() => {
  let isMounted = true;

  const fetchVehiculos = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/users/instaladores/`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (isMounted) {
        setVehiculos(response.data);
      }
    } catch (error) {
      console.error('Error al cargar los instaladores:', error);
      if (isMounted) {
        setError('No se pudo cargar la lista de instaladores.');
      }
    }
  };

  fetchVehiculos();

  return () => { isMounted = false; };
}, []);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };
  
    window.addEventListener('resize', handleResize);
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const buildPDF = async () => {
    const logoRes = await fetch('/ISOLOGOTIPO_NARANJA_BLANCO.png');
    const logoBlob = await logoRes.blob();
    const logoDataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(logoBlob);
    });
    const logoImg = new Image();
    await new Promise((resolve, reject) => {
      logoImg.onload = resolve;
      logoImg.onerror = reject;
      logoImg.src = logoDataUrl;
    });
    const logoAspectRatio = logoImg.naturalWidth / logoImg.naturalHeight;

    const doc = new jsPDF({ unit: 'mm', format: 'a4' });
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = { left: 15, right: 15, bottom: 20 };

    const headerBg    = [37, 109, 159];
    const accentColor = [255, 116, 58];
    const textColor   = [60, 60, 60];
    const mutedColor  = [120, 120, 120];
    const lightGray   = [245, 245, 245];

    const fmt = (v) => Number(v).toLocaleString('es-CL', { style: 'currency', currency: 'CLP' });

    const headerH = 32;
    doc.setFillColor(...headerBg);
    doc.rect(0, 0, pageWidth, headerH, 'F');

    const logoH = 14;
    const logoW = logoH * logoAspectRatio;
    doc.addImage(logoDataUrl, 'PNG', margin.left, (headerH - logoH) / 2, logoW, logoH);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(18);
    doc.setTextColor(255, 255, 255);
    doc.text(`Orden de Venta N° ${orden.id_orden}`, pageWidth - margin.right, 14, { align: 'right' });

    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.text(`Fecha: ${fechaCotizacion}`, pageWidth - margin.right, 21, { align: 'right' });

    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');
    doc.text((orden.estado || 'pendiente').toUpperCase(), pageWidth - margin.right, 27, { align: 'right' });

    let y = headerH + 10;

    const colL = margin.left;
    const colR = pageWidth / 2 + 5;

    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...textColor);
    doc.text('DATOS DEL CLIENTE', colL, y);
    doc.text('DATOS DEL PROYECTO', colR, y);

    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    const nombreCompleto = cliente ? `${cliente.nombre} ${cliente.apellido}` : '-';
    let yL = y + 6;
    let yR = y + 6;

    doc.text(nombreCompleto, colL, yL); yL += 5;
    doc.text(cliente?.email || '-', colL, yL); yL += 5;
    doc.text(cliente?.whatsapp || '-', colL, yL); yL += 5;
    const dir = [cotizacion.direccion_instalacion, cliente?.comuna].filter(Boolean).join(' - ');
    doc.text(dir || '-', colL, yL); yL += 5;

    doc.text(`N° Cotización: ${cotizacion.id_cotizacion}`, colR, yR); yR += 5;
    doc.text(`Servicio: ${cotizacion.tipo_instalacion || '-'}`, colR, yR); yR += 5;
    doc.text(`Dificultad: ${cotizacion.dificultad || '-'}`, colR, yR); yR += 5;
    doc.text(`Termopanel: ${cotizacion.termopanel || '-'}`, colR, yR); yR += 5;
    doc.text(`Retiro lámina: ${cotizacion.retiro_laminas ? 'Sí' : 'No'}`, colR, yR); yR += 5;

    y = Math.max(yL, yR) + 5;

    const grouped = cotizacion.detalles.reduce((acc, item) => {
      const key = `${item.item}-${item.alto}-${item.ancho}-${item.m2}-${item.total}`;
      if (!acc[key]) acc[key] = { ...item, cantidad: 1 };
      else acc[key].cantidad += 1;
      return acc;
    }, {});
    const groupedArr = Object.values(grouped);

    const tableRows = groupedArr.map(item => {
      const m2Tot = (parseFloat(item.m2) || 0) * item.cantidad;
      const priceTot = (parseFloat(item.total) || 0) * item.cantidad;
      return [item.item, `${item.alto || 'N/A'} x ${item.ancho || 'N/A'}`, item.cantidad, `${m2Tot.toFixed(2)} m²`, fmt(item.precio), fmt(priceTot)];
    });

    if (cotizacion.retiro_laminas)
      tableRows.push(['Retiro de láminas', '', '', '', '', fmt(cotizacion.monto_retiro_laminas)]);
    if (cotizacion.cobro_distancia)
      tableRows.push(['Monto por distancia', '', '', '', '', fmt(cotizacion.monto_distancia)]);
    if (cotizacion.dificultad !== 'normal')
      tableRows.push([`Dificultad: ${cotizacion.dificultad}`, '', '', '', '', fmt(cotizacion.monto_dificultad)]);

    doc.autoTable({
      startY: y,
      margin: { left: margin.left, right: margin.right },
      head: [['Ítem', 'Medidas', 'Cant.', 'M²', 'Precio m²', 'Total']],
      body: tableRows,
      styles: { fontSize: 9, textColor },
      headStyles: { fillColor: accentColor, textColor: 255, fontStyle: 'bold' },
      columnStyles: { 2: { halign: 'center' }, 3: { halign: 'center' }, 4: { halign: 'right' }, 5: { halign: 'right' } },
    });

    y = doc.lastAutoTable.finalY + 10;

    const sectionY = y;

    const bankData = [
      ['Nombre',         process.env.REACT_APP_NOMBRE_PAGO        || 'Film Solar Spa'],
      ['RUT',            process.env.REACT_APP_RUT_PAGO            || '78.025.351-7'],
      ['Banco',          process.env.REACT_APP_BANCO_PAGO          || 'Banco Santander'],
      ['Tipo de cuenta', process.env.REACT_APP_TIPO_CUENTA_PAGO    || 'Cuenta Corriente'],
      ['N° cuenta',      process.env.REACT_APP_NUMERO_CUENTA_PAGO  || '0-000-9629135-3'],
      ['Email de pago',  process.env.REACT_APP_MAIL_CUENTA_PAGO    || 'PagosFilmsolar@gmail.com'],
    ];

    const payW = 90;
    const payBoxH = bankData.length * 6 + 12;
    doc.setFillColor(...lightGray);
    doc.roundedRect(colL, y - 3, payW, payBoxH, 2, 2, 'F');

    doc.setFontSize(7.5);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...mutedColor);
    doc.text('INFORMACIÓN DE PAGO', colL + 4, y + 3);

    y += 9;
    bankData.forEach(([label, value]) => {
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...mutedColor);
      const ls = label + ': ';
      doc.text(ls, colL + 4, y);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...textColor);
      doc.text(value, colL + 4 + doc.getTextWidth(ls), y);
      y += 6;
    });

    const payEndY = sectionY - 3 + payBoxH + 8;
    y = sectionY;

    const subtotalItems = cotizacion.detalles.reduce((s, d) => s + (parseFloat(d.total) || 0), 0);
    const cargoRetiro     = cotizacion.retiro_laminas    ? (parseFloat(cotizacion.monto_retiro_laminas) || 0) : 0;
    const cargoDistancia  = cotizacion.cobro_distancia   ? (parseFloat(cotizacion.monto_distancia)       || 0) : 0;
    const cargoDificultad = cotizacion.dificultad !== 'normal' ? (parseFloat(cotizacion.monto_dificultad) || 0) : 0;
    const subtotal = subtotalItems + cargoRetiro + cargoDistancia + cargoDificultad;
    const ivaTotal = Math.round(subtotal * 0.19);
    const descuento = Math.round(subtotal * 1.19 - cotizacion.total_cotizacion);

    const totBoxX = pageWidth - margin.right - 70;
    const totBoxW = 70;
    const grayH = descuento > 0 ? 30 : 24;
    const vX = pageWidth - margin.right - 5;

    doc.setFillColor(...lightGray);
    doc.roundedRect(totBoxX, y - 3, totBoxW, grayH, 2, 2, 'F');

    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...textColor);

    doc.text('Subtotal',   totBoxX + 5, y + 2); doc.text(fmt(subtotal), vX, y + 2, { align: 'right' }); y += 6;
    doc.text('IVA (19%)', totBoxX + 5, y + 2); doc.text(fmt(ivaTotal), vX, y + 2, { align: 'right' }); y += 6;
    doc.text('Total m²',  totBoxX + 5, y + 2); doc.text(`${totalM2.toFixed(2)} m²`, vX, y + 2, { align: 'right' }); y += 6;

    if (descuento > 0) {
      const dLabel = cotizacion.campaign_info ? `Dcto. ${cotizacion.campaign_info.codigo}` : 'Descuento';
      doc.setTextColor(34, 139, 34);
      doc.text(dLabel, totBoxX + 5, y + 2);
      doc.text(`-${fmt(descuento)}`, vX, y + 2, { align: 'right' });
      doc.setTextColor(...textColor);
      y += 6;
    }

    const totH = 24;
    doc.setFillColor(...accentColor);
    doc.roundedRect(totBoxX, y, totBoxW, totH, 3, 3, 'F');
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(255, 255, 255);
    doc.text('TOTAL', totBoxX + 5, y + 8);
    doc.setFontSize(14);
    doc.text(fmt(cotizacion.total_cotizacion), vX, y + 8, { align: 'right' });

    y = Math.max(y + totH + 10, payEndY);

    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...textColor);
    doc.text('Términos y Condiciones', margin.left, y);
    y += 6;

    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    const terminos = [
      '1. Vigencia de la Cotización: 30 días desde su emisión.',
      '2. Condiciones de Pago: Abono mínimo requerido para reservar la instalación.',
      '3. Agenda: Se realiza entre 3 a 7 días hábiles después del abono.',
      '4. Garantía: Cubre desprendimiento de lámina, burbujas, descoloramiento y defectos de instalación.',
      '5. Exclusiones de Garantía: No incluye reposición de vidrios por fisuras de estrés térmico.',
      '6. Alcance del Servicio: Incluye láminas e instalación, con vida útil de hasta 10 años.',
    ];
    terminos.forEach(t => { doc.text(t, margin.left, y); y += 4; });

    const footerY = pageHeight - margin.bottom - 12;
    doc.setDrawColor(...mutedColor);
    doc.setLineWidth(0.3);
    doc.line(margin.left, footerY, pageWidth - margin.right, footerY);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(...mutedColor);
    doc.text('+56 9 66781957 | 12 Norte 785 of. 401 Edificio Pamplona | www.filmsolar.cl', pageWidth / 2, footerY + 6, { align: 'center' });

    return doc;
  };

  const handleDownloadPDF = async () => {
    try {
      setLoadingMessage('Generando PDF...');
      setIsProcessing(true);
      const doc = await buildPDF();
      doc.save(`OrdenVenta_${orden.id_orden}.pdf`);
    } catch (error) {
      alert('Hubo un problema al generar el PDF.');
    } finally {
      setIsProcessing(false);
    }
  };


  const handleAsignarClick = () => {
    setIsEditing(true); // Activar el modo de edición
  
    // Asegurarse de que el scroll ocurra después de renderizar los nuevos elementos
    setTimeout(() => {
      const container = document.querySelector('.responsive-div'); // Asegúrate de seleccionar el contenedor adecuado
      if (container) {
        container.scrollTo({
          top: container.scrollHeight, // Desplaza hasta el final del contenedor
          behavior: 'smooth' // Hace que el desplazamiento sea suave
        });
      }
    }, 300); // Aumenta el tiempo de espera si es necesario
  };

  // Función para obtener eventos y filtrar los horarios disponibles
  const fetchEventosYFiltrarHorarios = async (vehiculo, fecha) => {
    try {
      const token = localStorage.getItem('access_token');  // Obtén el token de localStorage
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/events/events/`, {
        params: {
          vehicle: vehiculo,
          fecha: fecha,
        },
        headers: {
          Authorization: `Bearer ${token}`,  // Asegúrate de incluir el token en los headers
        },
      });
  
      const eventos = response.data;
      console.error("fecha: ",response)
      // Filtrar los horarios ocupados
      const horariosOcupados = horariosDisponibles.map(horario => {
        const horarioOcupado = eventos.some(evento => {
          const eventDate = new Date(evento.start_time); // Convertimos el start_time a un objeto Date
          
          // Obtener la hora de Santiago (restamos 3 horas para ajustar de GMT 0 a GMT -3)
          const localStartHour = eventDate.getUTCHours() - 3;
      
          // Si la hora es negativa, ajustamos a 24 horas (por ejemplo, para las horas de la medianoche)
          const startHour = localStartHour < 0 ? localStartHour + 24 : localStartHour;
      
          console.error("hora inicio ajustada es: ", startHour)
      
          if (horario.value === '9-12' && startHour >= 9 && startHour < 12) {
            return true;
          }
          if (horario.value === '12-15' && startHour >= 12 && startHour < 15) {
            return true;
          }
          if (horario.value === '15-18' && startHour >= 15 && startHour < 18) {
            return true;
          }
          return false;
        });
        return { ...horario, disponible: !horarioOcupado };
      });
  
      setHorariosDisponibles(horariosOcupados);
    } catch (error) {
      console.error('Error al obtener eventos:', error);
    }
  };
    // Cuando cambien la fecha o el vehículo, buscar los eventos correspondientes
    useEffect(() => {
      if (selectedInstalador && fechaInstalacion) {
        fetchEventosYFiltrarHorarios(selectedInstalador, fechaInstalacion.toISOString().split('T')[0]);
      }
    }, [selectedInstalador, fechaInstalacion]);

    const handleGuardarClick = async () => {
      try {
        setLoadingMessage("Guardando cambios...");
        setIsProcessing(true);
        const token = localStorage.getItem('access_token');
    
        // Verificar si el estado de la orden es "pendiente_asignar"
        if (orden.estado === 'pendiente_asignar') {
          // Calcular start_time y end_time
          const [startHour] = rangoHoras.split('-').map(Number);
          const startDateTime = new Date(fechaInstalacion);
          startDateTime.setUTCHours(startHour + 3); // Ajustar a GMT -3 para Santiago
          const endDateTime = new Date(startDateTime);
          endDateTime.setUTCHours(startDateTime.getUTCHours() + 3); // Añadir 3 horas para el end_time
          // Obtener la comuna abreviada a 4 caracteres (valpo para Valparaíso)
          const abreviacionComuna = cliente.comuna
            ? cliente.comuna.slice(0, 4).toUpperCase()
            : 'N/A'; 
          // Determinar el subject según tipo_instalacion
          let subject = '';
          if (cotizacion.tipo_instalacion === 'instalacion') {
            subject = `INST${abreviacionComuna}`;
          } else if (cotizacion.tipo_instalacion === 'Visita') {
            subject = `VTEC${abreviacionComuna}`;
          }        
          // Extraer nombres únicos de las láminas solares
          const nombresLaminas = [...new Set(cotizacion.detalles.map(item => item.item))];
          const nombresLaminasStr = nombresLaminas.join(', ');      
          // Crear el payload para el evento
          const eventPayload = {
            subject: subject,
            location: `${cotizacion.direccion_instalacion} - ${cliente.comuna}`,
            start_time: startDateTime.toISOString(),  // Convertir a ISO string con la zona horaria ajustada
            end_time: endDateTime.toISOString(),
            category_color: "#ff0000",
            description: `Láminas: ${nombresLaminasStr} - M2: ${totalM2.toFixed(2)} - OV: ${orden.id_orden}`,
            vehicle: selectedInstalador,
            order: orden.id_orden  // ID de la orden
          };
    
          // Crear el evento
          await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/events/events/`, eventPayload, {
            headers: { Authorization: `Bearer ${token}` }
          });

          // Crear el payload para la nueva instalación
          const instalacionPayload = {
            orden: orden.id_orden,
            estado_instalacion: "pendiente",
            confirmar_recibida: null,
            confirmar_contacto: null,
            hora_salida: null,
            imagenes: [],
            notas_instalacion: null
          };

          // Crear la instalación
          await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/instalacion/instalacion/`, instalacionPayload, {
            headers: { Authorization: `Bearer ${token}` }
          });     
    
          // Crear el payload para actualizar la orden de venta
          const ordenPayload = {
            estado: "asignado",
            fecha_instalacion: startDateTime.toISOString(), // Usar el mismo startDateTime del evento
            instalador: selectedInstalador
          };
    
          // Actualizar la orden de venta
          await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/ordenes/${orden.id_orden}/`, ordenPayload, {
            headers: { Authorization: `Bearer ${token}` }
          });
    
          // Luego de guardar el evento y actualizar la orden, desactiva el modo de edición
          setIsEditing(false);
          refreshOrdenes();  // Actualiza las órdenes
        } else if (orden.estado === 'por_enviar') {
          const fechaEnvio = new Date().toISOString(); // Fecha actual en formato ISO
          // Crear el payload para actualizar la orden de venta cuando se está en "por_enviar"
          const ordenPayload = {
            estado: "enviado",
            numero_seguimiento: numeroSeguimiento,  // Número de seguimiento ingresado por el usuario
            fecha_instalacion: fechaEnvio,  // Fecha del momento de envío
            instalador: selectedInstalador
          };
          // Actualizar la orden de venta
          await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/ordenes/${orden.id_orden}/`, ordenPayload, {
            headers: { Authorization: `Bearer ${token}` }
          });
    
          // Luego de actualizar la orden, desactiva el modo de edición
          setIsEditing(false);
          refreshOrdenes();  // Actualiza las órdenes
        } else {
          console.log('El estado de la orden no es "pendiente_asignar" ni "por_enviar". No se realizan acciones.');
        }

        // Refrescar la grilla de órdenes
        if (refreshOrdenes) {
          await refreshOrdenes();
        }

        // Cerrar el modal
        if (onClose) {
          onClose();
        }        
      } catch (error) {
    alert('Error al guardar la orden.');
    console.error(error);
  } finally {
    setIsProcessing(false);
  }
};
  


  useEffect(() => {
    let isMounted = true; // Para controlar si el componente sigue montado

    // Función para obtener los detalles de la orden por su ID
    const fetchOrden = async () => {
      
      try {
        const token = localStorage.getItem('access_token');
        const responseOrden = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/ordenes/${ordenId}/`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if (isMounted) {
          setOrden(responseOrden.data);

          // Obtener la cotización asociada
          const cotizacionId = responseOrden.data.cotizacion;
          const responseCotizacion = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/cotizaciones/${cotizacionId}/`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setCotizacion(responseCotizacion.data);
          // Formatear la fecha y guardarla
          const formattedDate = new Date(responseCotizacion.data.fecha_cotizacion).toLocaleDateString('es-CL', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          });
          setFechaCotizacion(formattedDate);

                  // Calcular el total de metros cuadrados
          const totalMetros = responseCotizacion.data.detalles.reduce((total, item) => {
            return total + (parseFloat(item.m2) || 0);
          }, 0);
          setTotalM2(totalMetros);

          // Hacer el segundo llamado a la API para obtener los detalles del cliente usando solicitante
          
          if (responseCotizacion.data.solicitante) {
            const clienteResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/clientes/clientes/${responseCotizacion.data.solicitante}/`, {
              headers: { Authorization: `Bearer ${token}` }
            });
            setCliente(clienteResponse.data); 
          }
          
          setLoading(false);
        }
      } catch (error) {
        console.error('Error al cargar los detalles de la orden, cotización o cliente:', error);
        if (isMounted) {
          setError('No se pudo cargar la orden, la cotización o el cliente.');
          setLoading(false);
        }
      }
    };

    fetchOrden(); // Llamar a la función cuando se monte el componente

    return () => {
      isMounted = false; // Cleanup para prevenir memory leak
    };
  }, [ordenId]);

  const handleChangeEstado = async (nuevoEstado) => {
    try {
      setLoadingMessage(`Actualizando estado a ${nuevoEstado}...`);
      setIsProcessing(true);
      const token = localStorage.getItem('access_token');
      const response = await axios.patch(`${process.env.REACT_APP_BACKEND_URL}/api/ordenes/${ordenId}/cambiar_estado/`,
      { estado: nuevoEstado },
      {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Mostrar alertas informativas si las hay
      if (response.data?.alerts && response.data.alerts.length > 0) {
        setToast({ message: response.data.alerts.join(' | '), type: 'alert' });
        setIsProcessing(false);
        return;
      }
      if (response.data?.error) {
        setToast({ message: response.data.error, type: 'error' });
        setIsProcessing(false);
        return;
      }

      // Actualizar el estado localmente para reflejar el cambio sin necesidad de recargar
      setCotizacion((prevCotizacion) => ({
        ...prevCotizacion,
        estado: nuevoEstado
      }));

      // Refresca las órdenes en la grilla principal
      if (refreshOrdenes) {
        refreshOrdenes();
      }

      // Cierra el modal automáticamente
      if (onClose) {
        onClose();
      }
    } catch (error) {
    const errMsg = error.response?.data?.error || `Error al cambiar estado a ${nuevoEstado}.`;
    setToast({ message: errMsg, type: 'error' });
    console.error(error);
  } finally {
    setIsProcessing(false);
  }
};



  if (loading) {
    return <div>Cargando los detalles de la Orden de venta...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!cotizacion) {
    return <div>No se encontraron datos de la Orden.</div>;
  }

  const _subtotalBase = cotizacion.detalles.reduce((s, d) => s + (parseFloat(d.total) || 0), 0)
    + (cotizacion.retiro_laminas ? (parseFloat(cotizacion.monto_retiro_laminas) || 0) : 0)
    + (cotizacion.cobro_distancia ? (parseFloat(cotizacion.monto_distancia) || 0) : 0)
    + (cotizacion.dificultad !== 'normal' ? (parseFloat(cotizacion.monto_dificultad) || 0) : 0);
  const montoDescuentoCLP = Math.round(_subtotalBase * 1.19 - cotizacion.total_cotizacion);

  return (
    <>
      <div className="bg-half-transparent w-screen fixed nav-item top-0 right-0 h-full flex">
        
      <div className="responsive-div">
          <Toast message={toast.message} type={toast.type} onClose={() => setToast({ message: '', type: '' })} />
          <div className="flex justify-between items-center mb-6">
            <p className="font-semibold text-lg" style={{ color: '#FF743A' }}>Detalle Orden</p>
            <NavButton
              title="Cerrar"
              customFunc={onClose}
              color={currentColor}
              icon={<RiCloseCircleLine />}
              size="3xl"  // Aumenta el tamaño del ícono
              padding="p-4"  // Aumenta el padding del botón
            />
          </div>

          <div className="cotizacion-header">
            <div className="yellow-bar-left"></div>
            <h1 className="cotizacion-title">ORDEN VENTA {orden.id_orden}</h1>
            <div className="yellow-bar-right"></div>
          </div>
          {/* Información del cliente */}
          {cliente && (
            <div
              className={`cliente-info ${isSmallScreen ? "flex flex-col" : "flex flex-row justify-between"}`}
            >
              <div className={`${isSmallScreen ? "" : "left-info"} mb-4`}>
                <p><strong>Cliente: </strong>{cliente.nombre} {cliente.apellido}</p>
                <p className="direccion-text">
                  <strong>Dirección: </strong>{cotizacion.direccion_instalacion} - {cliente.comuna}
                </p>
              </div>
              <div className={`${isSmallScreen ? "" : "right-info"}`}>
                <p><strong>Teléfono/Wsp: </strong>{cliente.whatsapp}</p>
                <p><strong>Email: </strong><span>{cliente.email}</span></p>
              </div>
            </div>
          )}
          {cliente && (
            <div className="cliente-info">
              <div className="left-info">
              <p><strong>Estado:</strong> {orden.estado}</p>
                {orden.fecha_instalacion && (
                  <p><strong>Fecha Instalación:</strong> {moment(orden.fecha_instalacion).format('DD/MM/YYYY')}</p>
                )}
                <p><strong>Tipo Servicio:</strong> {cotizacion.tipo_instalacion}</p>
                <p><strong>Vendedor:</strong> {cotizacion.vendedor?.username || "No asignado"}</p>
                {orden.estado !== 'enviado' && (
                  <p><strong>Instalador:</strong> {orden.instalador ? orden.instalador : 'Pendiente Asignar'}</p>
                )}
                <p><strong>N° Cotización: </strong>{cotizacion.id_cotizacion}</p>
              </div>
              <div className="right-info">
                <p><strong>Retiro Lamina:</strong> {cotizacion.retiro_laminas ? "Sí" : "No"}</p>
                <p><strong>Dificultad:</strong> {cotizacion.dificultad}</p>
                <p><strong>Tipo Propiedad:</strong> {cotizacion.tipo_propiedad}</p>
                <p><strong>Tipo Servicio:</strong> {cotizacion.tipo_instalacion}</p>
                {orden.numero_seguimiento && (
                  <p><strong>Seguimiento:</strong> {orden.numero_seguimiento}</p>
                )}
              </div>
            </div>
          )}


          {cotizacion.campaign_info && (
            <div className="bg-orange-50 border border-orange-200 rounded-xl p-3 mb-4 mx-1">
              <p className="text-sm font-semibold text-orange-700 mb-1">Origen: Campaña de mailing</p>
              <div className="flex flex-wrap gap-x-4 gap-y-1">
                <p className="text-xs text-gray-600"><strong>Campaña:</strong> {cotizacion.campaign_info.campaign_nombre}</p>
                <p className="text-xs text-gray-600"><strong>Código:</strong> {cotizacion.campaign_info.codigo}</p>
                <p className="text-xs text-gray-600"><strong>Destinatario:</strong> {cotizacion.campaign_info.email_destinatario}</p>
                <p className="text-xs text-gray-600">
                  <strong>Descuento:</strong>{' '}
                  {cotizacion.campaign_info.valor_descuento}{cotizacion.campaign_info.tipo_descuento === 'porcentaje' ? '%' : ' CLP'}
                  {montoDescuentoCLP > 0 && (
                    <span className="text-green-700 font-semibold ml-1">
                      (−{montoDescuentoCLP.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })})
                    </span>
                  )}
                </p>
              </div>
            </div>
          )}

        <div className="overflow-x-auto w-full" style={{ minWidth: 0 }}>
        <table className="items-table table-auto border-collapse w-full">
            <thead>
            <tr className="bg-gray-100">
                <th>Nº</th>
                <th>Item</th>
                <th>Precio (m²)</th>
                <th>Cant.</th>
                {isSmallScreen ? (
                  <th>Medidas</th>
                ) : (
                  <>
                    <th>Alto</th>
                    <th>Ancho</th>
                  </>
                )}
                <th>M²</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {(() => {
                // Agrupa los detalles por columnas clave
                const groupedDetails = cotizacion.detalles.reduce((acc, item) => {
                  const key = `${item.item}-${item.alto}-${item.ancho}-${item.m2}-${item.total}`;
                  if (!acc[key]) {
                    acc[key] = { ...item, cantidad: 1 };
                  } else {
                    acc[key].cantidad += 1;
                  }
                  return acc;
                }, {});
                console.error("groupedDetails",Object.values(groupedDetails))
                // Convierte el objeto agrupado en un array para iterar
                const groupedArray = Object.values(groupedDetails);

                // Renderizar filas agrupadas
                const rows = groupedArray.map((item, index) => {
                  const totalM2 = (parseFloat(item.m2) || 0) * item.cantidad;
                  const totalPrecio = (parseFloat(item.total) || 0) * item.cantidad;

                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.item}</td>
                      <td>{(item.precio / 1).toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</td>
                      <td>{item.cantidad}</td>
                {isSmallScreen ? (
                  <td>{`${item.alto || 'N/A'} x ${item.ancho || 'N/A'}`}</td>
                ) : (
                  <>
                    <td>{item.alto || 'N/A'}</td>
                    <td>{item.ancho || 'N/A'}</td>
                  </>
                )}
                      <td>{totalM2 ? `${totalM2.toFixed(2)}` : 'N/A'}</td>
                      <td>{totalPrecio ? `$${totalPrecio.toLocaleString()}` : 'N/A'}</td>
                    </tr>
                  );
                });

                // Agregar filas adicionales
                let extraRowIndex = groupedArray.length;
                if (cotizacion.retiro_laminas) {
                  rows.push(
                    <tr key="retiro_laminas">
                      <td>{++extraRowIndex}</td>
                      {isSmallScreen ? (
                        <td colSpan="5">Retiro de láminas</td>
                      ) : (
                        <td colSpan="6">Retiro de láminas</td>
                      )}
                      <td>{`$${parseFloat(cotizacion.monto_retiro_laminas).toLocaleString()}`}</td>
                    </tr>
                  );
                }

                if (cotizacion.cobro_distancia) {
                  rows.push(
                    <tr key="cobro_distancia">
                      <td>{++extraRowIndex}</td>
                      {isSmallScreen ? (
                        <td colSpan="5">Monto por distancia</td>
                      ) : (
                        <td colSpan="6">Monto por distancia</td>
                      )}
                      <td>{`${(cotizacion.monto_distancia).toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}`}</td>
                    </tr>
                  );
                }

                if (cotizacion.dificultad !== 'normal') {
                  rows.push(
                    <tr key="dificultad">
                      <td>{++extraRowIndex}</td>
                      {isSmallScreen ? (
                        <td colSpan="5">{`Dificultad: ${cotizacion.dificultad}`}</td>
                      ) : (
                        <td colSpan="6">{`Dificultad: ${cotizacion.dificultad}`}</td>
                      )}
                      <td>{`${parseFloat(cotizacion.monto_dificultad).toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}`}</td>
                    </tr>
                  );
                }

                // Subtotal = suma de todos los ítems + cargos adicionales
                const subtotalItems = cotizacion.detalles.reduce((sum, d) => sum + (parseFloat(d.total) || 0), 0);
                const cargoRetiro = cotizacion.retiro_laminas ? (parseFloat(cotizacion.monto_retiro_laminas) || 0) : 0;
                const cargoDistancia = cotizacion.cobro_distancia ? (parseFloat(cotizacion.monto_distancia) || 0) : 0;
                const cargoDificultad = cotizacion.dificultad !== 'normal' ? (parseFloat(cotizacion.monto_dificultad) || 0) : 0;
                const subtotal = subtotalItems + cargoRetiro + cargoDistancia + cargoDificultad;

                // IVA sobre el subtotal real
                const ivaTotal = subtotal * 0.19;

                // Descuento = diferencia entre (subtotal + IVA) y el total final
                const montoDescuento = Math.round(subtotal * 1.19 - cotizacion.total_cotizacion);

                // Fila subtotal
                rows.push(
                  <tr key="subtotal" className="border-t-2 border-gray-200">
                    <td></td>
                    {isSmallScreen ? (
                      <td colSpan="5" className="font-semibold text-gray-700">Subtotal</td>
                    ) : (
                      <td colSpan="6" className="font-semibold text-gray-700">Subtotal</td>
                    )}
                    <td className="font-semibold">{subtotal.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</td>
                  </tr>
                );

                // Fila IVA
                rows.push(
                  <tr key="iva">
                    <td></td>
                    {isSmallScreen ? (
                      <td colSpan="5">IVA (19%)</td>
                    ) : (
                      <td colSpan="6">IVA (19%)</td>
                    )}
                    <td>{ivaTotal.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</td>
                  </tr>
                );

                // Fila descuento (campaña o regular)
                if (montoDescuento > 0) {
                  const descuentoLabel = cotizacion.campaign_info
                    ? `Descuento campaña ${cotizacion.campaign_info.codigo} (${cotizacion.campaign_info.valor_descuento}${cotizacion.campaign_info.tipo_descuento === 'porcentaje' ? '%' : ' CLP'})`
                    : `Descuento ${parseFloat(cotizacion.descuento).toLocaleString()}%`;
                  rows.push(
                    <tr key="descuento">
                      <td></td>
                      {isSmallScreen ? (
                        <td colSpan="5" className="text-green-700 font-medium">{descuentoLabel}</td>
                      ) : (
                        <td colSpan="6" className="text-green-700 font-medium">{descuentoLabel}</td>
                      )}
                      <td className="text-green-700 font-medium">-{montoDescuento.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</td>
                    </tr>
                  );
                }
                return rows;
              })()}
            </tbody>
        </table>
        </div>

          {/* Monto total debajo de la tabla */}
          <div className="flex justify-end mt-4">
            <p className="font-semibold text-lg">Total: {(cotizacion.total_cotizacion / 1).toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</p>
          </div>

          {/* Monto total de m² debajo de la tabla */}
          <div className="flex justify-end mt-2">
            <p className="font-semibold text-lg">Total m²: {totalM2.toFixed(2)} m²</p>
          </div>



          <div className="flex flex-col md:flex-row justify-between mt-4 space-y-2 md:space-y-0 md:space-x-2">
            {/* Botón Descargar PDF y los demás botones en la misma fila */}
            {!isEditing && (
              <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-2">
            <button onClick={handleDownloadPDF} type="button" 
            className="bg-[#FF743A] text-white p-2 rounded-lg hover:bg-[#e8632e] transition duration-200 w-full md:w-auto"
            >
              Descargar
            </button>

            <a
              href={
                cliente
                  ? `https://web.whatsapp.com/send?phone=${cliente.whatsapp.replace(/[^0-9]/g, '')}&text=${encodeURIComponent(
                      `Estimado Sr. ${cliente.nombre} ${cliente.apellido},

              Adjunto encontrará la Orden N°${orden.id_orden}, junto con la ficha técnica del film, el cual cumple con todas las características solicitadas.

              Detalles de la cotización:
              - Metros cuadrados (m²): ${totalM2.toFixed(2)}
              - Total: $${cotizacion.total_cotizacion.toLocaleString('es-CL')}
              - Tipo de servicio: ${cotizacion.tipo_instalacion}

              Ante cualquier consulta adicional, quedamos atentos para responder a la brevedad.

              Saludos cordiales,
              Equipo FilmSolar`
                    )}`
                  : '#'
              }
              target="_blank"
              rel="noopener noreferrer"
              className={`inline-flex items-center justify-center bg-green-500 text-white p-2 rounded-lg ${
                cliente ? 'hover:bg-green-600' : 'cursor-not-allowed'
              } transition duration-200 ml-2`}
              onClick={(e) => {
                if (!cliente) {
                  e.preventDefault();
                  alert('Los datos del cliente aún no están disponibles.');
                }
              }}
              >
              <FaWhatsapp className="mr-2" /> Enviar por Wsp
              </a>            
        </div>


          
          
            )}
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-2">
            {orden.estado === 'pendiente_asignar' && (
              <>
                {isEditing ? (
                  <div className="mt-4">
                  <h3 className="text-lg font-semibold">Asignar Instalador</h3>

                  <div className="flex flex-col">
                    <label className="mt-2">Vehículo:</label>
                    <select
                      className="border p-2 rounded-lg"
                      value={selectedInstalador}
                      onChange={(e) => setSelectedInstalador(e.target.value)}
                    >
                      <option value="">Seleccione un instalador</option>
                      {vehiculos.map((instalador) => (
                        <option key={instalador.id} value={instalador.username}>
                          {instalador.username}
                        </option>
                      ))}
                    </select>

                    <label className="mt-2">Fecha de instalación:</label>
                    <DatePicker
                      className="border p-2 rounded-lg"
                      selected={fechaInstalacion}
                      onChange={(date) => setFechaInstalacion(date)}
                      minDate={new Date()}
                      placeholderText="Seleccione una fecha"
                      dateFormat="dd/MM/yyyy"
                      locale="es"
                      calendarStartDay={1}
                      filterDate={(date) => date.getDay() !== 0}
                    />

                    <label className="mt-2">Rango horario:</label>
                    <select
                      className="border p-2 rounded-lg"
                      value={rangoHoras}
                      onChange={(e) => setRangoHoras(e.target.value)}
                    >
                      <option value="">Seleccione un rango de horas</option>
                      {horariosDisponibles
                        .filter((horario) => horario.disponible)
                        .map((horario) => (
                          <option key={horario.value} value={horario.value}>
                            {horario.label}
                          </option>
                        ))}
                    </select>

                      {/* Botones de Guardar y Cancelar */}
                      <div className="flex justify-between mt-4 pb-6">
                        <button
                          type="button"
                          className="bg-green-500 text-white p-2 rounded-lg hover:bg-green-600 transition duration-200"
                          onClick={handleGuardarClick}
                        >
                          Guardar
                        </button>
                        <button
                          type="button"
                          className="bg-red-500 text-white p-2 rounded-lg hover:bg-red-600 transition duration-200"
                          onClick={() => setIsEditing(false)}
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    {/* Botón Asignar */}
                    <button
                      type="button"
                      className="bg-green-500 text-white p-2 rounded-lg hover:bg-green-600 transition duration-200 w-full md:w-auto"
                      onClick={handleAsignarClick}
                    >
                      Asignar
                    </button>
                    <button
                      type="button"
                      className="bg-red-500 text-white p-2 rounded-lg hover:bg-red-600 transition duration-200 w-full md:w-auto"
                      onClick={() => handleChangeEstado('rechazado')}
                    >
                      Rechazar
                    </button>
                  </>
                )}
              </>
            )}

              {orden.estado === 'por_enviar' && (
              <>
                {isEditing ? (
                  <div className="mt-4">
                  <h3 className="text-lg font-semibold">Número seguimiento</h3>

                  <div className="flex flex-col">
                  <label className="mt-2">N° Seguimiento:</label>
                    <input
                      type="text"
                      className="border p-2 rounded-lg"
                      placeholder="Ingrese seguimiento"
                      value={numeroSeguimiento}
                      onChange={(e) => setNumeroSeguimiento(e.target.value)}
                    />
                  
                      {/* Botones de Guardar y Cancelar */}
                      <div className="flex justify-between mt-4 pb-6">
                        <button
                          type="button"
                          className="bg-green-500 text-white p-2 rounded-lg hover:bg-green-600 transition duration-200"
                          onClick={handleGuardarClick}
                        >
                          Guardar
                        </button>
                        <button
                          type="button"
                          className="bg-red-500 text-white p-2 rounded-lg hover:bg-red-600 transition duration-200"
                          onClick={() => setIsEditing(false)}
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    {/* Botón Asignar */}
                    <button
                      type="button"
                      className="bg-green-500 text-white p-2 rounded-lg hover:bg-green-600 transition duration-200 mr-4"
                      onClick={handleAsignarClick}
                    >
                      Enviar
                    </button>
                    <button
                      type="button"
                      className="bg-red-500 text-white p-2 rounded-lg hover:bg-red-600 transition duration-200"
                      onClick={() => handleChangeEstado('rechazado')}
                    >
                      Rechazar
                    </button>
                  </>
                )}
              </>
            )}


</div>
          </div>
        </div>
      </div>
      {isProcessing && <LoadingOverlay message={loadingMessage} />}
    </>
  );
};

export default DetalleOrden;
